import { QueryClient } from '@tanstack/react-query';

const QUERY_CLIENT_DEFAULT_OPTIONS = {
  queries: {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
    staleTime: Infinity
  }
};

export class QueryClientSingleton {
  private static instance: QueryClient;

  private constructor() {}

  public static getInstance(): QueryClient {
    if (!QueryClientSingleton.instance) {
      QueryClientSingleton.instance = new QueryClient({
        defaultOptions: QUERY_CLIENT_DEFAULT_OPTIONS
      });
    }

    return QueryClientSingleton.instance;
  }

  public static resetInstance(): void {
    QueryClientSingleton.instance.clear();
    QueryClientSingleton.instance = new QueryClient({
      defaultOptions: QUERY_CLIENT_DEFAULT_OPTIONS
    });
  }

  public static freezeInstance(): void {
    if (QueryClientSingleton.instance) {
      QueryClientSingleton.instance.setDefaultOptions({
        queries: { enabled: false }
      });
    }
  }
}

export default {
  get queryClient() {
    return QueryClientSingleton.getInstance();
  }
};
